import React from "react";

import { Box } from "@mui/material";
import { postfixes, symbols } from "root/utils";
import { getDateByDayBack } from "root/utils/date";
import { daysMS } from "root/utils/date/constant";
import { tooltips } from "root/utils/tooltips";

import { TrendRequestsCircleRating } from "root/pages/trend-requests/components/ByParameters/RatingSelector";

import { numberWithSpaces } from "root/js/utils";

const getRatingValue = v => {
  if (v < 1 || v > 100 || isNaN(v)) return 0;
  if (v <= 20) return 1; // Ужасные
  if (v <= 35) return 2; // Плохие
  if (v <= 50) return 3; // Средние
  if (v <= 75) return 4; // Хорошие
  if (v <= 100) return 5; // Лучшие
};

//
export const trendRequestsParamsTypes = {
  current: "current",
  reports: "reports",
};
const types = trendRequestsParamsTypes;
// --------------------------------------------------------------------------
const trendRequestsParams = [
  {
    dataIndex: "rating",
    title: "Рейтинг качества запроса",
    hint: "Рейтинг рассчитывается исходя из значений показателей выручки, частотности, рекламы, монополизации, количества отзывов и других параметров",
    render: v => <TrendRequestsCircleRating count={getRatingValue(v)} />,
    default: true,
  },
  {
    dataIndex: "diff_percent30",
    title: "Динамика за 30 дн.",
    hasTarget: true,
    postfix: postfixes.percent,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "diff_percent60",
    title: "Динамика за 60 дн.",
    hasTarget: true,
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "diff_percent90",
    title: "Динамика за 90 дн.",
    hasTarget: true,
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "days30",
    title: "Частотность за 30 дн.",
    type: types.reports,
    alwaysVisible: true,
    default: true,
  },
  {
    dataIndex: "days60",
    title: "Частотность за 60 дн.",
    type: types.reports,
  },
  {
    dataIndex: "days90",
    title: "Частотность за 90 дн.",
    type: types.reports,
  },
  // {
  //   dataIndex: "avg_diff_reviews_top100",
  //   title: "Ср. прирост отзывов на артикул в топ 100 за 30 дн.",
  //   hint: "Средний прирост количества отзывов на 1 артикул за 30 дней среди органической выдачи в топ-100 по запросу.",
  //   postfix: postfixes.pcs,
  //   type: types.reports,
  //   default: true,
  //   minDate: new Date("2026-01-26"),
  // },
  {
    dataIndex: "quantile_diff_reviews_top100",
    title: "Средний прирост отзывов у топ-100 за 30 дн.",
    hint: "Среднее количество новых отзывов, полученных артикулами, находящимися в топ-100 по органическим позициям за 30 дней от выбранной даты отсчета без учета рекламных товаров",
    postfix: postfixes.pcs,
    type: types.reports,
    default: true,
    // minDate: new Date("2026-01-26"),
  },
  {
    dataIndex: "proceeds_diff_reviews_top100",
    title: "Средний ВНО у топ-100 за 30 дн.",
    hint: (
      <Box sx={{ textAlign: "start" }}>
        ВНО (Выручка от новых отзывов) у артикулов из топ-100 за последние 30 дней от выбранной даты
        отсчета без учета рекламных товаров.
        <br />
        <br />
        Рассчитывается за анализируемый период как: (Число новых отзывов) × (Средняя цена товара без
        СПП).
        <br />
        <br />
        Показатель используется для примерной оценки минимального количества заказов артикула, когда
        данные об остатках недоступны.
        <br />
        <br />
        Поскольку у разных товаров разная конверсия заказов в отзывы, для оценки выручки через ВНО
        (при условии, что остатки были ограничены) можно использовать два метода:
        <br />
        <br />
        <b>Метод 1.</b>
        Проанализировать соотношение «заказы / отзывы» за период, когда данные были полными
        (например, до 15.09.25), и применить это соотношение к текущим данным об отзывах.
        <br />
        <br />
        <b>Метод 2.</b> Умножить количество отзывов (ВНО) на коэффициент от 3 до 5
      </Box>
    ),
    postfix: postfixes.rub,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "proceeds",
    title: "Выручка за 30 дн. у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "lost_proceeds",
    title: "Упущенная выручка за 30 дн. у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
  },
  {
    dataIndex: "potential_proceeds",
    title: "Потенциал выручки за 30 дн. у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
  },
  {
    dataIndex: "avg_proceeds_product",
    title: "Средняя выручка за 30 дн. у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
  },
  {
    dataIndex: "avg_proceeds_product_sales",
    title: "Средняя выручка за 30 дн. у артикулов с продажами на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "percent_lost_proceeds",
    title: "Процент упущенной выручки за 30 дн. у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "percent_proceeds_top30",
    title: "Монопольность",
    // hint: "Показатель характеризует, какой % выручки приходится на топ-10 артикулов, отсортированных по выручке, на первой странице. Считается как сумма выручки топ-10 артикулов / сумму выручки топ-100 артикулов в нише.",
    hint: tooltips.monopoly,
    postfix: postfixes.percent,
    type: types.reports,
    default: true,
  },
  {
    dataIndex: "orders",
    title: "Количество заказов у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.pcs,
    type: types.reports,
  },
  {
    dataIndex: "lost_orders",
    title: "Упущенные заказы у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.pcs,
    type: types.reports,
  },
  {
    dataIndex: "percent_lost_orders",
    title: "Процент упущенных заказов у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "potential_orders",
    title: "Потенциал заказов у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.pcs,
    type: types.reports,
  },
  {
    dataIndex: "avg_price",
    title: "Средняя цена у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "median_price",
    title: "Медианная цена у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.rub,
    type: types.reports,
  },
  {
    dataIndex: "percent_count_products_advertising",
    title: "Процент артикулов в рекламе на первой странице",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "percent_products_external_traffic",
    title: "Процент артикулов с внешним трафиком на первой странице",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "products",
    title: "Количество артикулов по запросу",
    postfix: postfixes.pcs,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "demand_coefficient_product",
    title: "Отношение частотности запроса к количеству артикулов по запросу",
    hint: "Коэффициент спроса. Показатель рассчитывается на последнюю дату анализируемого периода",
    default: true,
    type: types.reports,
    render: v => (isNaN(v) ? symbols.none : numberWithSpaces(v, 2)),
  },
  {
    dataIndex: "percent_products_sales",
    title: "Процент артикулов с продажами у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "percent_sellers_sales",
    title: "Процент поставщиков с продажами у артикулов на первых 3-х страницах",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "avg_reviews_top100",
    title: "Среднее общее количество отзывов у артикулов в топ 100",
    hint: "Показатель рассчитывается на последнюю дату анализируемого периода",
    postfix: postfixes.pcs,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "subject_percent_sales",
    title: "Процент выкупа",
    postfix: postfixes.percent,
    default: true,
    type: types.reports,
  },
  {
    dataIndex: "subject_fbo",
    title: "Комиссия FBO",
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "subject_fbs_to_fbo",
    title: "Комиссия FBS",
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "subject_fbs_self_deliver",
    title: "Комиссия DBS",
    postfix: postfixes.percent,
    type: types.reports,
  },
  {
    dataIndex: "subject_fbs_self_deliver_express",
    title: "Комиссия DBS Express",
    postfix: postfixes.percent,
    type: types.reports,
  },
].map(item => ({
  ...item,
  title: item.postfix ? `${item.title}, ${item.postfix.trim()}` : item.title,
}));
// -----------------------------------------------------------------------------
const trendRequestsSeasonality = {
  option: 0,
  list_month_is_seasonality: [],
  list_month_is_up_trend: [],
  list_month_is_dow_trend: [],
};
const getTrendRequestsSeasonalityParams = seasonality => {
  const obj = {};
  switch (seasonality.option) {
    case 0:
      break;
    case 1:
      obj.is_seasonality__isnull = true;
      break;
    case 2:
      obj.is_seasonality__exact = true;
      break;
    case 3:
      obj.is_seasonality__exact = false;
      break;
  }
  if (seasonality.list_month_is_seasonality.length && ![1, 3].includes(seasonality.option))
    obj.list_month_is_seasonality__contains = seasonality.list_month_is_seasonality?.join();
  if (seasonality.list_month_is_up_trend.length)
    obj.list_month_is_up_trend__contains = seasonality.list_month_is_up_trend?.join();
  if (seasonality.list_month_is_dow_trend.length)
    obj.list_month_is_dow_trend__contains = seasonality.list_month_is_dow_trend?.join();

  return obj;
};
// --------------------------------------------------------------------------
const reduxTrendRequestsParams = trendRequestsParams.reduce((acc, item) => {
  if (item.hasTarget) {
    acc[item.dataIndex] = {
      target: null,
      gte: "",
      lte: "",
    };
    acc[item.dataIndex] = {
      target: null,
      gte: "",
      lte: "",
    };
  } else {
    acc[item.dataIndex + "__lte"] = "";
    acc[item.dataIndex + "__gte"] = "";
  }
  return acc;
}, {});
reduxTrendRequestsParams.name__icontains = "";
//
const checkHaveTrendRequestsParamsFilters = params => {
  for (const key in params) {
    if (typeof params[key] === "object") {
      if (params[key].target !== null && (params[key].gte || params[key].lte)) return true;
    } else {
      if (params[key]) return true;
    }
  }
  return false;
};
//
const defaultTrendRequestsCreateData = getDateByDayBack(30);
// --------------------------------------------------------------------------
const trendRequestsSelectors = {
  // create_date: new Date(Date.now() - daysMS),
  create_date: new Date(new Date() - daysMS),
  subject_ids: [],
  rating_range__in: [],
};

export {
  trendRequestsParams,
  reduxTrendRequestsParams,
  checkHaveTrendRequestsParamsFilters,
  defaultTrendRequestsCreateData,
  trendRequestsSelectors,
  trendRequestsSeasonality,
  getTrendRequestsSeasonalityParams,
};
